// extracted by mini-css-extract-plugin
module.exports = {"promo":"_87395b9"};